import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
    NbAuthComponent,
    NbLoginComponent,
    NbLogoutComponent,
    NbRegisterComponent,
    NbRequestPasswordComponent,
    NbResetPasswordComponent,
} from '@nebular/auth';
import { LoginComponent } from './login/login/login.component';
import { DefinicaoSenhaComponent } from './login/definicao-senha/definicao-senha.component';

const routes: Routes = [
    { path: 'pages', loadChildren: 'app/pages/pages.module#PagesModule' },
	{ path: 'login', component: LoginComponent },
	{ path: 'login/definir-senha/:hash', component: DefinicaoSenhaComponent },
    { path: '', redirectTo: 'pages/usuarios', pathMatch: 'full' },
    { path: '**', redirectTo: 'pages/usuarios' },

];

const config: ExtraOptions = {
	useHash: true,
	onSameUrlNavigation:'reload'
};

@NgModule({
    imports: [RouterModule.forRoot(routes, config)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts